export enum EndProductReasonEnum {
    NotNeeded = 'Insurance Not Needed',
    Premium = 'Insurance Premium Does Not Fit',
    Other = 'Other reason',
}
